import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { DeliveryVoucher } from 'contracts/DeliveryVouchers';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_DELIVERY_VOUCHERS_',
  }
);

export interface ListDeliveryVouchersState {
  data: DeliveryVoucher[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListDeliveryVouchersRequestAction {
  query?: Record<string, any>;
  onSuccess?: (data: DeliveryVoucher[]) => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: DeliveryVoucher[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListDeliveryVouchersState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListDeliveryVouchersState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListDeliveryVouchersState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListDeliveryVouchersState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListDeliveryVouchersState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listDeliveryVouchers = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListDeliveryVouchersTypes = Types;
export const ListDeliveryVouchersActions = Creators;
